import { render } from "./CardFigurinha.vue?vue&type=template&id=7fb0d137&scoped=true"
import script from "./CardFigurinha.vue?vue&type=script&lang=js"
export * from "./CardFigurinha.vue?vue&type=script&lang=js"

import "./CardFigurinha.vue?vue&type=style&index=0&id=7fb0d137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb0d137"]])

export default __exports__